import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createClass from "@babel/runtime/helpers/createClass";
import { ID_ARG_KEY_SELECTOR } from "../constants";

var SelectorSpec = /*#__PURE__*/function () {
  function SelectorSpec(_ref) {
    var parent = _ref.parent,
        orm = _ref.orm;
    this._parent = parent;
    this._orm = orm;
    this.keySelector = ID_ARG_KEY_SELECTOR;
  }

  _createClass(SelectorSpec, [{
    key: "cachePath",
    get: function get() {
      var basePath = this._parent ? this._parent.cachePath : [];
      return [].concat(_toConsumableArray(basePath), [this.key]);
    }
  }, {
    key: "orm",
    get: function get() {
      return this._orm;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    }
  }]);

  return SelectorSpec;
}();

export { SelectorSpec as default };